export default __webpack_public_path__ + "static/media/check.497e1348.svg";